import SliderModule from './slider'
import { isWithinValidity } from '../../helper/validity'

/**
 *
 * @param props
 * @returns
 */
const PdfReader = props => {
  const moduleSettings = props.moduleSettings
  // https://github.com/akiran/react-slick
  var sliderSettings = {
    autoplay: true,
    autoplaySpeed: Number(moduleSettings.duration),
    fade: moduleSettings.fade,
    infinite: true
  }
  let key = 0
  const images = moduleSettings.images
  let imageGalery = {}

  // Signage validity (optional). The whole gallery is gated by its own
  // valid-from/valid-to window; when the gallery is currently valid, each image
  // is additionally gated by its own window. Missing bounds = no limit.
  const now = new Date()
  const galleryVisible = isWithinValidity(
    moduleSettings.validFrom,
    moduleSettings.validTo,
    now
  )

  if (images && galleryVisible) {
    imageGalery = Object.values(images)
      .filter(img => isWithinValidity(img.validFrom, img.validTo, now))
      .map(img => (
        <div key={key + 1}>
          <img style={img.style} src={img.path} alt={'datavision'} />
        </div>
      ))
    return <SliderModule settings={sliderSettings} content={imageGalery} />
  }
  return false
}
export default PdfReader
